module.exports = __webpack_public_path__ + "img/word.803c6e88.svg";